export default __webpack_public_path__ + "static/media/certified-by-RIVM.8445bc9a.svg";